import z from 'zod'

export const TicketGateConfigSchema = z.object({
  targetStateId: z.string().optional(),
  targetTicketGroupIdProp: z.string().default('subgroup_id'),
})

export type TicketGateConfig = z.infer<typeof TicketGateConfigSchema>
